import React from 'react';
import Select from 'components/global/CUK/AsyncSelect/Select';
import { components } from 'react-select';
import { useTranslation } from 'react-i18next';
import { Typography, useTheme, Box, ClickAwayListener } from '@mui/material';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';
import StateIcon from 'components/global/StateIcon';

const DropdownIndicator = ({ ...props }) => {
  const theme = useTheme()
  return (
    <Box mr={1}>
      {props.selectProps.menuIsOpen ? (
        <StateIcon
          iconlabel={'angle-up'}
          iconweight={'regular'}
          iconcolor={theme.palette.primary.main}
        />
      ) : (
        <StateIcon iconweight={'regular'} iconlabel={'angle-down'} />
      )}
    </Box>
  )
}

const ValueContainer = ({ ...props }) => {
  const theme = useTheme()
  const selectedValuesCount = props.getValue().length
  const { menuIsOpen } = props.selectProps

  return (
    <components.ValueContainer {...props}>
      <Box>
      <Typography
          sx={{
            color: menuIsOpen ? '#3B82F6' : theme.palette.grey[500],
            fontSize: '12px',
            paddingLeft: theme.spacing(1.5),
            fontWeight: 500,
          }}
        >
          {selectedValuesCount === 0
            ? props.selectProps.placeholder
            : `${selectedValuesCount} sélectionnés`}
        </Typography>
      </Box>
    </components.ValueContainer>
  )
}

const Option = (props) => {
  return (
    <OptionMultiCount
      {...props}
      value={props.data}
      count={props.data.count}
      availability={props.data.value}
    />
  )
}

const StatusSelect = ({ onChange, values = [], apiCount = {} }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  
  const stepCounts = apiCount?.step || {};
  
  const choices = [
    {
      label: t('audin_document.status.validated', {count: stepCounts.validated ?? null}),
      value: 'validated',
      count: stepCounts.validated ?? 0,
      id: 1,
    },
    {
      label: t('audin_document.status.in_progress'),
      value: 'draft',
      count: stepCounts.draft ?? 0,
      id: 2,
    },
  ]

  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={choices}
      mainField="label"
      placeholder={t('audin_document.filter.status_placeholder')}
      onChange={(values) => onChange(values.map(({ value }) => value))}
      components={{
        Option,
        Control: ({ children, ...props }) => {
          const { menuIsOpen, onMenuClose, onMenuOpen } = props.selectProps
          return (
            <components.Control {...props}>
              <ClickAwayListener
                mouseEvent='onMouseDown'
                onClickAway={() => {
                  onMenuClose()
                }}
              >
                <Box
                  onClick={() => {
                    if (menuIsOpen) {
                      onMenuClose()
                    } else {
                      onMenuOpen()
                    }
                  }}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexGrow: 1,
                    gap: 7,
                    cursor : 'pointer'
                  }}
                >
                  {children}
                </Box>
              </ClickAwayListener>
            </components.Control>
          )
        },
        MenuList: ({ children, ...props }) => {
          return (
            <components.MenuList {...props}>
              {children}
              <Box
                ml={1}
                mt={1}
                color={'grey.600'}
                fontSize={12}
                fontWeight={500}
                onClick={() => props.setValue([])}
                sx={{
                  cursor: 'pointer',
                  '&:hover': {
                    color: theme.palette.grey[800],
                  },
                }}
              >
                {t('actions.deselect_all')}
              </Box>
            </components.MenuList>
          )
        },
        DropdownIndicator,
        ValueContainer,
        Placeholder: (props) => (
          <Box>
            <components.Placeholder {...props} />
          </Box>
        ),
        IndicatorSeparator: null,
        ClearIndicator: null,
      }}
      value={choices.filter(
        (choice) => values.findIndex((value) => choice.value === value) > -1,
      )}
    />
  )
}

export default StatusSelect